<template>
  <div>
    <div class="fixed">
      <!-- 筛选框 -->
      <div class="filter-date">
        <div class="filter-left">
          <div class="date" @click="showYm = true">
            {{ String(versionInfo.ym) | date('MM月 YYYY') }} {{ versionInfo.version }}<img src="/arrow_down.png" />
          </div>
          <div class="appeal">
            <div v-if="versionInfo.fillInEndTime">填写截止至：{{ versionInfo.fillInEndTime }}</div>
            <div v-else>不在窗口期</div>
          </div>
        </div>
        <div :class="{ filter: true, 'filter-non': !isFilter, 'filter-active': isFilter }" @click="showFilter = true">
          <img src="/filter.png" v-if="!isFilter" />
          <img src="/filter_active.png" v-else />
        </div>
      </div>
    </div>
    <!-- 列表 -->
    <div class="list">
      <!-- 数据展示 -->
      <div class="data">
        <div class="data-info">
          <div class="data-title">预估数量(标准)</div>
          <div class="data-content">{{ summaryInfo.estimateQty | numberFormat(false) }}</div>
        </div>
        <div class="data-info">
          <div class="data-title">预估金额</div>
          <div class="data-content">{{ summaryInfo.estimateAmount | numberFormat(false) }}</div>
        </div>
        <div class="data-info">
          <div class="data-title">预估达成(数量)</div>
          <div class="data-content">{{ summaryInfo.estimateAchievementQty | numberFormat(false, true) }}</div>
        </div>
        <div class="data-info">
          <div class="data-title">预估达成(金额)</div>
          <div class="data-content">{{ summaryInfo.estimateAchievementAmount | numberFormat(false, true) }}</div>
        </div>
      </div>
      <!-- 表格 -->
      <div class="table-container">
        <div class="table-title">
          <div class="first-title">填写统计</div>
          <div>MR已填写：{{ summaryInfo.fillRatio }}</div>
        </div>
        <StatisticsTable
          :tableData="statisticsData"
          :ipagination="ipagination"
          :total="statisticsTotal"
          :params="{
            ...queryParam,
            ...versionInfo,
            productLineId,
            productName,
            brandGroup,
            ahUserName,
            asmUserName,
            dsmUserName,
          }"
          @change="getStatisticsTable"
        ></StatisticsTable>
      </div>
    </div>
    <van-popup v-model="showFilter" round position="bottom" get-container="#app" :style="{ height: '80%' }">
      <div class="filter-title">筛选<img src="/filter_close.png" @click="showFilter = false" /></div>
      <div class="filter-box">
        <!-- 筛选框 -->
        <van-form>
          <van-row>
            <van-col span="24" class="input-title">Brand Group</van-col>
            <van-col span="24">
              <van-field
                class="filter-input"
                readonly
                clickable
                v-model="brandGroup"
                placeholder="请选择Brand Group"
                @click="showBrandGroup = true"
              >
                <template #right-icon>
                  <span class="solts input-icon">
                    <van-icon name="clear" v-if="brandGroup" @click.stop="clearSelect('brandGroup')" />
                    <van-icon name="arrow-down" v-else />
                  </span>
                </template>
              </van-field>
            </van-col>
            <van-col span="24" class="input-title">品牌</van-col>
            <van-col span="24">
              <van-field
                class="filter-input"
                readonly
                clickable
                v-model="productLineName"
                placeholder="请选择品牌"
                @click="showProductLine = true"
              >
                <template #right-icon>
                  <span class="solts input-icon">
                    <van-icon name="clear" v-if="productLineId" @click.stop="clearSelect('productLineId')" />
                    <van-icon name="arrow-down" v-else />
                  </span>
                </template>
              </van-field>
            </van-col>
            <van-col span="24" class="input-title">Sales Group</van-col>
            <van-col span="24">
              <van-field
                class="filter-input"
                readonly
                clickable
                v-model="productName"
                placeholder="请选择Sales Group"
                @click="showSalesGroup = true"
              >
                <template #right-icon>
                  <span class="solts input-icon">
                    <van-icon name="clear" v-if="productName" @click.stop="clearSelect('productName')" />
                    <van-icon name="arrow-down" v-else />
                  </span>
                </template>
              </van-field>
            </van-col>
            <van-col span="24" class="input-title">NSD</van-col>
            <van-col span="24">
              <van-field
                class="filter-input"
                readonly
                clickable
                v-model="ahUserName"
                placeholder="请选择NSD"
                @click="showNsd = true"
              >
                <template #right-icon>
                  <span class="solts input-icon">
                    <van-icon name="clear" v-if="ahUserName" @click.stop="clearSelect('ahUserName')" />
                    <van-icon name="arrow-down" v-else />
                  </span>
                </template>
              </van-field>
            </van-col>
            <van-col span="24" class="input-title">RM</van-col>
            <van-col span="24">
              <van-field
                class="filter-input"
                readonly
                clickable
                v-model="asmUserName"
                placeholder="请选择RM"
                @click="showRm = true"
              >
                <template #right-icon>
                  <span class="solts input-icon">
                    <van-icon name="clear" v-if="asmUserName" @click.stop="clearSelect('asmUserName')" />
                    <van-icon name="arrow-down" v-else />
                  </span>
                </template>
              </van-field>
            </van-col>
            <van-col span="24" class="input-title">DM</van-col>
            <van-col span="24">
              <van-field
                class="filter-input"
                readonly
                clickable
                v-model="dsmUserName"
                placeholder="请选择DM"
                @click="showDm = true"
              >
                <template #right-icon>
                  <span class="solts input-icon">
                    <van-icon name="clear" v-if="dsmUserName" @click.stop="clearSelect('dsmUserName')" />
                    <van-icon name="arrow-down" v-else />
                  </span>
                </template>
              </van-field>
            </van-col>
          </van-row>

          <div class="filter-btn">
            <van-button class="btn" round block @click="reset">重置</van-button>
            <van-button class="btn" round block type="info" @click="search">应用</van-button>
          </div>
        </van-form>
      </div>
    </van-popup>
    <!-- YM选择框 -->
    <van-popup v-model="showYm" round position="bottom" :style="{ height: '50%' }">
      <van-picker
        :item-height="60"
        show-toolbar
        :columns="versionList"
        value-key="showValue"
        @confirm="confirmDate"
        @cancel="showYm = false"
      />
      <!-- <van-datetime-picker
        v-model="currentDate"
        type="year-month"
        title="选择年月"
        @confirm="confirmDate"
        @cancel="showYm = false"
      /> -->
    </van-popup>
    <!-- Brand Group -->
    <van-popup v-model="showBrandGroup" position="bottom">
      <van-search v-model="brandGroupValue" @input="searchBrandGroup" placeholder="搜索Brand Group" />
      <van-picker
        :item-height="60"
        show-toolbar
        :columns="brandGroupResultList"
        value-key="brandGroup"
        @confirm="confirmBrandGroup"
        @cancel="showBrandGroup = false"
      />
    </van-popup>
    <!-- 品牌 -->
    <van-popup v-model="showProductLine" position="bottom">
      <van-search v-model="productLineValue" @input="searchProductLine" placeholder="搜索品牌" />
      <van-picker
        :item-height="60"
        show-toolbar
        :columns="productLineResultList"
        value-key="product_line_name"
        @confirm="confirmProductLine"
        @cancel="showProductLine = false"
      />
    </van-popup>
    <!-- Sales Group -->
    <van-popup v-model="showSalesGroup" position="bottom">
      <van-search v-model="salesGroupValue" @input="searchSalesGroup" placeholder="搜索Sales Group" />
      <van-picker
        :item-height="60"
        show-toolbar
        :columns="salesGroupResultList"
        @confirm="confirmSalesGroup"
        @cancel="showSalesGroup = false"
      />
    </van-popup>
    <!-- NSD -->
    <van-popup v-model="showNsd" position="bottom">
      <van-search v-model="nsdValue" @input="searchNsd" placeholder="搜索NSD" />
      <van-picker
        :item-height="60"
        show-toolbar
        :columns="nsdResultList"
        value-key="ahUserName"
        @confirm="confirmNsd"
        @cancel="showNsd = false"
      />
    </van-popup>
    <!-- RM -->
    <van-popup v-model="showRm" position="bottom">
      <van-search v-model="rmValue" @input="searchRm" placeholder="搜索RM" />
      <van-picker
        :item-height="60"
        show-toolbar
        :columns="rmResultList"
        value-key="asmUserName"
        @confirm="confirmRm"
        @cancel="showRm = false"
      />
    </van-popup>
    <!-- DM -->
    <van-popup v-model="showDm" position="bottom">
      <van-search v-model="dmValue" @input="searchDm" placeholder="搜索DM" />
      <van-picker
        :item-height="60"
        show-toolbar
        :columns="dmResultList"
        value-key="dsmUserName"
        @confirm="confirmDm"
        @cancel="showDm = false"
      />
    </van-popup>
  </div>
</template>

<script>
import { getAction, postAction } from '@/api/manage'
import _ from 'lodash'
import moment from 'moment'
import StatisticsTable from './StatisticsTable.vue'
export default {
  components: {
    StatisticsTable,
  },
  data() {
    return {
      loading: false,
      refreshing: false,
      finished: false,
      showFilter: false, // 筛选框
      showYm: false, // YM选择
      showProductLine: false, // 显示品牌
      showSalesGroup: false, // 显示Sales Group
      showBrandGroup: false, // 显示Brand Group
      showNsd: false, // 显示NSD
      showRm: false, // 显示Rm
      showDm: false, // 显示Dm
      isFilter: false, // 是否进行过搜索
      currentDate: new Date(),
      pageNo: 1, // 分页
      summaryInfo: {}, // 填写汇总
      queryParam: {
        ym: moment().format('YYYYMM'),
      },

      productLineId: null, // 品牌
      productLineName: null, // 品牌名称
      productLineValue: '', // 品牌搜索内容
      productLineList: [], // 品牌列表
      productLineResultList: [], // 品牌搜索结果列表
      productName: null, // Sales Group名称
      salesGroupValue: '', // Sales Group搜索内容
      salesGroupList: [], // Sales Group列表
      salesGroupResultList: [], // Sales Group搜索结果列表
      brandGroup: null, // Brand Group名称
      brandGroupValue: '', // Brand Group搜索内容
      brandGroupList: [], // Brand Group列表
      brandGroupResultList: [], // Brand Group搜索结果列表
      ahUserName: null, // NSD
      nsdValue: '', // NSD搜索内容
      nsdList: [], // NSD列表
      nsdResultList: [], // NSD搜索结果列表
      asmUserName: null, // RM
      rmValue: '', // RM搜索内容
      rmList: [], // RM列表
      rmResultList: [], // RM搜索结果列表
      dsmUserName: null, // DM
      dmValue: '', // DM搜索内容
      dmList: [], // DM列表
      dmResultList: [], // DM搜索结果列表
      canCopy: true, // 是否支持全部复制
      recentWindows: {}, // 需要复制的预估版本信息
      tableActive: 'detail', // 表格tab默认展示
      /* 分页参数 */
      ipagination: {
        pageNo: 1,
        pageSize: 20,
        total: 0,
      },
      statisticsTotal: 0, // 表格总条数
      statisticsData: [], // 表格数据
      versionList: [], // 版本列表
      versionInfo: {
        ym: moment().format('YYYYMM'),
      }, // 版本信息
    }
  },
  computed: {},
  watch: {
    'versionInfo.ym': {
      handler: function (val) {
        this.pageNo = 1
        // 清空列表数据
        this.finished = false
        // 重新加载数据
        this.loading = true
        this.isFilter = false
        this.statisticsData = []
        // this.getVersionList()
        this.getProductLine()
        this.getSalesGroup()
        this.getBrandGroup()
        this.getNsd()
        this.getRm()
        this.getDm()
        this.$nextTick(() => {
          this.getSummary()
          this.getStatisticsTable()
        })
      },
      deep: true, //深度侦听
    },
  },
  mounted() {
    this.getVersionList()
    // this.getProductLine()
    // this.getSalesGroup()
    // this.getBrandGroup()
    // this.getNsd()
    // this.getRm()
    // this.getDm()
  },
  methods: {
    // 选择YM
    confirmDate(val) {
      // this.queryParam.ym = moment(String(val.ym)).format('YYYYMM')
      this.versionInfo = val
      this.showYm = false
    },
    // 清空下拉框
    clearSelect(select) {
      if (select === 'productLineId') {
        this.productLineId = null
        this.productLineName = null
      } else if (select === 'productName') {
        this.productName = null
      } else if (select === 'brandGroup') {
        this.brandGroup = null
      } else if (select === 'ahUserName') {
        this.ahUserName = null
      } else if (select === 'asmUserName') {
        this.asmUserName = null
      } else if (select === 'dsmUserName') {
        this.dsmUserName = null
      }
    },

    // 选择品牌
    confirmProductLine(val) {
      console.log('选择品牌------', val)
      this.productLineId = val.product_line_id
      this.productLineName = val.product_line_name
      this.showProductLine = false
    },
    // 选择Sales Group
    confirmSalesGroup(val) {
      console.log('选择Sales Group------', val)
      this.productName = val
      this.showSalesGroup = false
    },
    // 选择Brand Group
    confirmBrandGroup(val) {
      console.log('选择Brand Group------', val)
      this.brandGroup = val.brandGroup
      this.showBrandGroup = false
    },
    // 选择NSD
    confirmNsd(val) {
      console.log('选择NSD------', val)
      this.ahUserName = val.ahUserName
      this.showNsd = false
    },
    // 选择RM
    confirmRm(val) {
      console.log('选择RM------', val)
      this.asmUserName = val.asmUserName
      this.showRm = false
    },
    // 选择DM
    confirmDm(val) {
      console.log('选择DM------', val)
      this.dsmUserName = val.dsmUserName
      this.showDm = false
    },

    // 搜索品牌
    searchProductLine: _.debounce(function (val) {
      const keyword = val.toLowerCase()
      this.productLineResultList = this.productLineList.filter(item =>
        item.product_line_name.toLowerCase().includes(keyword)
      )
    }, 500),
    // 搜索Sales Group
    searchSalesGroup: _.debounce(function (val) {
      const keyword = val.toLowerCase()
      this.salesGroupResultList = this.salesGroupList.filter(item => item.toLowerCase().includes(keyword))
    }, 500),
    // 搜索Brand Group
    searchBrandGroup: _.debounce(function (val) {
      const keyword = val.toLowerCase()
      this.brandGroupResultList = this.brandGroupList.filter(item => item.brandGroup.toLowerCase().includes(keyword))
    }, 500),
    // 搜索NSD
    searchNsd: _.debounce(function (val) {
      const keyword = val.toLowerCase()
      this.nsdResultList = this.nsdList.filter(item => item.ahUserName.toLowerCase().includes(keyword))
    }, 500),
    // 搜索RM
    searchRm: _.debounce(function (val) {
      const keyword = val.toLowerCase()
      this.rmResultList = this.rmList.filter(item => item.asmUserName.toLowerCase().includes(keyword))
    }, 500),
    // 搜索DM
    searchDm: _.debounce(function (val) {
      const keyword = val.toLowerCase()
      this.dmResultList = this.dmList.filter(item => item.dsmUserName.toLowerCase().includes(keyword))
    }, 500),

    // 获取品牌下拉框
    getProductLine() {
      this.productLineList = []
      this.productLineResultList = []
      this.productLineId = null
      this.productLineName = null
      getAction('/sip/estimate/detail/getProductLine', {
        ym: this.versionInfo.ym,
      }).then(res => {
        console.log('获取品牌数据------', res)
        this.productLineList = res.result
        this.productLineResultList = [...this.productLineList]
      })
    },

    // 获取Sales Group下拉框
    getSalesGroup() {
      this.salesGroupList = []
      this.salesGroupResultList = []
      this.productName = null
      getAction('/sip/estimate/detail/salesGroup', {
        ym: this.versionInfo.ym,
      }).then(res => {
        console.log('获取Sales Group数据------', res)
        this.salesGroupList = res.result
        this.salesGroupResultList = [...this.salesGroupList]
      })
    },
    // 获取Brand Group下拉框
    getBrandGroup() {
      this.brandGroupList = []
      this.brandGroupResultList = []
      this.brandGroup = null
      getAction('/sip/estimate/overview/getBrandGroupByYm', {
        ym: this.versionInfo.ym,
      }).then(res => {
        console.log('获取Brand Group数据------', res)
        this.brandGroupList = res.result
        this.brandGroupResultList = [...this.brandGroupList]
      })
    },
    // 获取NSD下拉框
    getNsd() {
      this.nsdList = []
      this.nsdResultList = []
      this.ahUserName = null
      getAction('/sip/estimate/overview/getAhListByYm', {
        ym: this.versionInfo.ym,
      }).then(res => {
        console.log('获取NSD数据------', res)
        this.nsdList = res.result
        this.nsdResultList = [...this.nsdList]
      })
    },
    // 获取RM下拉框
    getRm() {
      this.rmList = []
      this.rmResultList = []
      this.asmUserName = null
      getAction('/sip/estimate/overview/getAsmUserNameListByYm', {
        ym: this.versionInfo.ym,
      }).then(res => {
        console.log('获取RM数据------', res)
        this.rmList = res.result
        this.rmResultList = [...this.rmList]
      })
    },
    // 获取DM下拉框
    getDm() {
      this.dmList = []
      this.dmResultList = []
      this.dsmUserName = null
      getAction('/sip/estimate/overview/getDsmUserNameListByYm', {
        ym: this.versionInfo.ym,
      }).then(res => {
        console.log('获取DM数据------', res)
        this.dmList = res.result
        this.dmResultList = [...this.dmList]
      })
    },

    // 获取版本下拉列表
    getVersionList() {
      getAction('/sip/estimate/overview/mobile/versionList').then(res => {
        console.log('获取版本下拉列表', res)
        this.versionList = res.result
        this.versionList.forEach(item => {
          this.$set(item, 'showValue', moment(String(item.ym)).format('YYYYMM') + ' ' + item.version)
        })
        this.versionInfo = res.result[0]
        // // 获取版本统计
        // this.getSummary()
        // // 获取版本列表
        // this.getStatisticsTable()
        // this.getProductLine()
        // this.getSalesGroup()
        // this.getBrandGroup()
        // this.getNsd()
        // this.getRm()
        // this.getDm()
      })
    },

    // 查询
    search() {
      this.pageNo = 1
      // 清空列表数据
      this.finished = false
      // 重新加载数据
      this.loading = true
      this.statisticsData = []
      this.getSummary()
      this.getStatisticsTable()
      this.showFilter = false
      if (
        this.productLineId ||
        this.productName ||
        this.brandGroup ||
        this.ahUserName ||
        this.asmUserName ||
        this.dsmUserName
      ) {
        this.isFilter = true
      } else {
        this.isFilter = false
      }
      // Vue.ls.set('queryParam', this.queryParam)
      // Vue.ls.set('filterDate', this.filterDate)
    },
    // 重置
    reset() {
      // this.queryParam = {}
      this.productLineId = null
      this.productLineName = null
      this.productName = null
      this.brandGroup = null
      this.ahUserName = null
      this.asmUserName = null
      this.dsmUserName = null
      // Vue.ls.remove('queryParam')
      this.isFilter = false
      this.showFilter = false
      this.pageNo = 1
      // 清空列表数据
      this.finished = false
      // 重新加载数据
      this.loading = true
      this.statisticsData = []
      this.getSummary()
      this.getStatisticsTable()
    },
    // 获取版本统计
    getSummary() {
      let params = {
        ...this.queryParam,
        ...this.versionInfo,
        productLineId: this.productLineId,
        productName: this.productName,
        brandGroup: this.brandGroup,
        ahUserName: this.ahUserName,
        asmUserName: this.asmUserName,
        dsmUserName: this.dsmUserName,
      }
      postAction('/sip/estimate/overview/fillStatisticsBasedOnMrSummary', params).then(res => {
        console.log('获取版本统计------', res)
        this.summaryInfo = res.result
      })
    },
    // 获取详情表格
    getStatisticsTable(pagination = 1) {
      this.ipagination.pageNo = pagination
      let params = {
        ...this.queryParam,
        ...this.versionInfo,
        productLineId: this.productLineId,
        productName: this.productName,
        brandGroup: this.brandGroup,
        ahUserName: this.ahUserName,
        asmUserName: this.asmUserName,
        dsmUserName: this.dsmUserName,
      }
      postAction('/sip/estimate/overview/fillInStatisticsByRm', params, { params: this.ipagination }).then(res => {
        console.log('按详情表格------', res)
        if (res.success) {
          res.result.records.forEach((v, i) => {
            this.$set(v, 'id', v.asmTerritoryId)
          })
          this.statisticsData = res.result.records
          this.statisticsTotal = res.result.total
        } else {
          this.$toast(res.message)
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.table-container {
  overflow-x: auto;
  width: 100%;
  margin-top: 10px;
  .table-title {
    height: 32px;
    font-size: 12px;
    color: #626262;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    // padding: 0 20px;
    div {
      height: 32px;
      line-height: 32px;
      text-align: center;
    }
    .first-title {
      width: 80px;
      position: relative;
    }
    .first-title::before {
      content: '';
      position: absolute;
      left: 0;
      bottom: 0; /* 调整下划线位置 */
      width: 100%;
      height: 3px; /* 下划线粗细 */
      background-color: #72c9ec; /* 下划线颜色 */
    }
    div:last-child {
      padding-right: 15px;
    }
  }
}

/deep/ .el-table th {
  background-color: #f2f2f2 !important; /* 修改背景颜色为蓝色 */
}
.fixed {
  width: 100%;
  position: fixed;
  min-height: 50px;
  z-index: 999;
  background-color: #f6f7fb;
  padding-bottom: 20px;
}
// 筛选框
.filter-date {
  margin-top: 25px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px 0 10px;
  .filter-left {
    .date {
      font-size: 20px;
      font-weight: 600;
      color: #555;
      display: flex;
      align-items: center;
      img {
        width: 10px;
        height: 7px;
        margin-left: 10px;
      }
    }
    .appeal {
      font-size: 12px;
      color: #7f7f7f;
      margin-top: 5px;
    }
  }
  .filter-right {
    display: flex;
    align-items: center;
    justify-self: space-around;
    div:first-child {
      margin-right: 10px;
    }
  }
  .filter {
    width: 30px;
    height: 30px;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 15px;
      height: 15px;
    }
  }
  .filter-non {
    background: #fff;
  }
  .filter-active {
    background: #5cc0eb;
  }
}

// 数据展示
.data {
  width: 100%;
  height: 124px;
  font-size: 12px;
  color: #4e7092;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-top: 10px;
  &-info {
    flex: 1;
    margin: 0 5px 5px 0;
    width: calc((100% - 10px) / 2);
    min-width: calc((100% - 10px) / 2); // 加入这两个后每个item的宽度就生效了
    max-width: calc((100% - 10px) / 2); // 加入这两个后每个item的宽度就生效了
    // text-align: center;
    padding-left: 50px;
  }
  &-info:nth-child(2n) {
    // 去除第2n个的margin-right
    margin-right: 0;
  }
  &-content {
    font-size: 16px;
    font-weight: 600;
    margin-top: 5px;
  }
}

// 列表
.list {
  padding-top: 95px;
  padding-bottom: 50px;
}

// 筛选框
.filter-box {
  margin-top: 65px;
  padding: 0 25px;
  padding-bottom: 80px;
}
.filter-title {
  width: 100%;
  height: 50px;
  color: #555;
  background: #fff;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  font-weight: 600;
  padding: 17px;
  z-index: 9999;
  border-top-right-radius: 16px;
  border-top-left-radius: 16px;
  border-bottom: 1px solid #f2f2f2;
  img {
    width: 14px;
    height: 14px;
  }
}
.input-title {
  font-size: 12px;
  color: #4e7092;
  margin-bottom: 10px;
}
.filter-input {
  width: 100%;
  height: 40px;
  font-size: 12px;
  border: 1px solid #aaa;
  border-radius: 8px;
  margin-bottom: 20px;
  padding: 0 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.input-icon {
  display: flex;
  align-items: center;
}
.filter-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  left: 0;
  bottom: 0;
  padding: 10px 20px;
  background-color: #fff;
  // margin-top: 28px;
  .btn {
    width: 140px;
    height: 43px;
    font-size: 13px;
    color: #4e7092;
    border-radius: 16px;
    background: #f2f2f2;
    line-height: 43px;
  }
  .van-button--info {
    background-color: #6fc3ff;
    color: #fff;
    border: none;
  }
}
</style>
